module.exports = __webpack_public_path__ + "img/elvas-castelo.c6e8e363.jpg";